export const environment = {
  production: false,
  envName: 'rc',
  baseFixUrl: 'https://marketing-rc.fixdigitalcrm.com/',
  baseUrl: 'https://marketing-rc.fixdigitalcrm.com/api/crm/webapp/v1/',
  baseUrlV1: "https://marketing-rc.fixdigitalcrm.com/api/crm/webapp/v1/",
  baseUrlV2: "https://marketing-rc.fixdigitalcrm.com/api/crm/webapp/v2/",
  version: "2.5.8"
};
